<template>
  <div class="animated fadeIn" id="list-sirens">
    <transition name="fade">
      <b-card no-body>
        <div class="card-smallHeader card-header-action" v-b-toggle.collapse1>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <span class="when-opened">
              <i class="icon-arrow-down"></i>
            </span>
            <span class="when-closed">
              <i class="icon-arrow-up"></i>
            </span>
          </div>
        </div>
        <div v-if="isLoadingDates">
          <LoadingField />
        </div>
        <div v-else-if="lastDateDeathWasCreated || lastDateDisabilityWasCreated" class="py-2 px-3 mb-3 d-flex align-items-center flex-wrap" style="font-size: 0.82rem; border-bottom: 1px solid #eee;">

          <span class=" font-italic mr-2">Dernier chargement : </span>
          <template>
            <div v-if="lastDateDisabilityWasCreated" class="d-flex align-items-center">
              <span class="badge badge-warning">Invalidité</span>
              <i class="fa fa-calendar-check-o text-info ml-2"></i>
              <span class="ml-2 font-weight-bold">{{ lastDateDisabilityWasCreated }}</span>
            </div>

            <span class="ml-3 mr-3">|</span>

            <div v-if="lastDateDeathWasCreated" class="d-flex align-items-center mr-3">
               <span class="badge badge-danger">Décès</span>
              <i class="fa fa-calendar-check-o text-info ml-2"></i>
              <span class="ml-2 font-weight-bold">{{ lastDateDeathWasCreated }}</span>
            </div>
          </template>

        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="search">
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Décompte</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="type_decompte"><strong>Type de décompte</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select size="sm" id="type_decompte" v-model="type_decompte"
                                   :options="typesDecomptes"></b-form-select>
                  </b-col>
                  <b-col sm="1">
                    <label for="num_decompte"><strong>N° décompte</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input class="" type="number" id="num_decompte" size="sm"
                                  v-model="num_decompte"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="amountStatus"><strong>Type</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select size="sm" id="amountStatus" v-model="amountStatus"
                                   :options="amountStatusOptions"></b-form-select>
                  </b-col>
                </b-row>

                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="date_du"><strong>Paiement du</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_du" size="sm"
                                  v-model="date_du"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="date_au"><strong>Paiement au</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_au" size="sm"
                                  v-model="date_au"></b-form-input>
                  </b-col>
                </b-row>
                <!-- début du champs de recherche du chargement -->
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="date_chargement_debut_decompte"><strong>Chargement du</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_chargement_debut_decompte" size="sm"
                                  v-model="date_chargement_debut_decompte"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="date_chargement_fin_decompte"><strong>Chargement au</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_chargement_fin_decompte" size="sm"
                                  v-model="date_chargement_fin_decompte"></b-form-input>
                  </b-col>
                </b-row>
                <!-- fin du champs de recherche du chargement -->
              </b-card>
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Salarié</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="nom"><strong>Nom salarié</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="nom" size="sm" v-model="nom"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="prenom"><strong>Prénom salarié</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="prenom" size="sm" v-model="prenom"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="nir"><strong>N°SS</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="nir" size="sm" v-model="nir"></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Etablissement / Contrat</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="siren"><strong>SIREN</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="siren" size="sm" v-model="siren"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="raison_sociale"><strong>Raison Sociale</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="raison_sociale" size="sm" v-model="raison_sociale"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="id_pp"><strong>N°Identifiant NSI</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="id_pp" size="sm" v-model="id_pp"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="num_dossier"><strong>N° Dossier</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="num_dossier" size="sm" v-model="num_dossier"></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="search" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
              <div class="mt-2">
                <span class="field-error">{{ errors.critere_recherche }}</span>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
    <b-card no-body>
      <b-card-header class="card-smallHeader">
        <i class="fa fa-list mr-2"></i>
        <span><strong>Liste des décomptes Inval/DC</strong></span>
      </b-card-header>
      <b-card-body>
        <decomptes-table
          :tableEntry="tableParam"
          ref="decomptes_table"
          @export-all-decomptes-inval="triggerExportAllDecomptesInval">
        </decomptes-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '@/utils/auth';
  import {downloadFile, isEmpty, getFileIcon, getTimestamp} from "@/utils/fileHelper";
  import DecomptesTable from './DecomptesTable'
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper";
  import LoadingField from '@/components/LoadingField.vue';

  export default {
    components: {DecomptesTable, LoadingField},
    data() {
      return {
        lastDateDeathWasCreated: '',
        lastDateDisabilityWasCreated: '',
        isLoadingDates: false,
        isReady: false,
        num_decompte: '',
        montant_decompte: '',
        type_decompte: 'dcinval',
        statut_decompte: '',
        date_du: '',
        date_au: '',
        date_chargement_debut_decompte: '',
        date_chargement_fin_decompte: '',
        nom: '',
        prenom: '',
        nir: '',
        siren: '',
        nic: '',
        raison_sociale: '',
        numero_contrat: '',
        famille_produit: '',
        nom_cev: '',
        prenom_cev: '',
        email_cev: '',
        allStatus: [],
        decompteIds: null,
        typesDecomptes: [],
        allFamillesProduits: [],
        statusDecomptes: [],
        errors: {
          critere_recherche: '',
          checkbox_1: '',
          checkbox_2: '',
        },
        isEmpty,
        noSearch: "noSearch",
        fromEG: false,
        num_dossier: '',
        id_pp: '',
        getTimestamp,
        amountStatus: '',
        amountStatusOptions: [
          {
            text: 'Tous',
            value: ''
          },
          {
            text: 'Décompte positif',
            value: '1',
          },
          {
            text: 'Décompte à zéro',
            value: '2',
          },
          {
            text: 'Décompte négatif',
            value: '3',
          },
        ],
      };
    },
    mounted() {
      this.getTypesDecomptes();
    },
    computed: {
      tableParam: {
        get() {
          let request = {};
          request.amountStatus = this.amountStatus;
          request.num_decompte = this.num_decompte;
          request.montant_decompte = this.montant_decompte;
          request.type_decompte = this.type_decompte;
          request.statut_decompte = this.statut_decompte;
          request.date_du = this.date_du;
          request.date_au = this.date_au;
          request.date_chargement_debut_decompte = this.date_chargement_debut_decompte;
          request.date_chargement_fin_decompte = this.date_chargement_fin_decompte;
          request.siren = this.siren.replace(/ /g, "")
          this.siren = request.siren
          request.nic = this.nic;
          request.raison_sociale = this.raison_sociale;
          request.numero_contrat = this.numero_contrat;
          request.famille_produit = this.famille_produit;
          request.nom_cev = this.nom_cev;
          request.prenom_cev = this.prenom_cev;
          request.email_cev = this.email_cev;
          request.nom = this.nom;
          request.prenom = this.prenom;
          request.nir = this.nir.replace(/ /g, "")
          this.nir = request.nir
          request.show_periodes = this.showPeriodes;
          request.decompte_ids = this.decompteIds;
          request.noSearch = this.noSearch;
          request.fromEG = this.fromEG
          request.num_dossier = this.num_dossier
          request.id_pp = this.id_pp
          return request;
        }
      },
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common['Accept'] = 'application/json';
      this.$axios.defaults.headers.common['Provider'] = getProvider();
      this.fetchLastDates();
    },
    methods: {
      fetchLastDates() {
        this.isLoadingDates = true;
        Promise.all([
          this.$axios.get('/espaceBeneficiaire/decomptes/derniere_date_decompte_DC_chargee'),
          this.$axios.get('/espaceBeneficiaire/decomptes/derniere_date_decompte_inval_chargee')
        ])
        .then(([deathRes, invalRes]) => {
          this.lastDateDeathWasCreated = deathRes.data.latestDate;
          this.lastDateDisabilityWasCreated = invalRes.data.latestDate;
        })
        .catch(() => {
          this.handleError();
        })
        .finally(() => {
          this.isLoadingDates = false;
        });
      },
      getTypesDecomptes(){
        if(hasRule(rules.CAN_ACCESS_DECOMPTE_INVAL) && hasRule(rules.CAN_ACCESS_DECOMPTE_DC)){
          this.typesDecomptes.push({ text: 'Tous', value: 'dcinval'});
          this.typesDecomptes.push({ text: 'Invalidité', value: 'inval'});
          this.typesDecomptes.push({ text: 'Décès', value: 'dc'});
        }
        else if(hasRule(rules.CAN_ACCESS_DECOMPTE_INVAL)){
          this.typesDecomptes.push({ text: 'Invalidité', value: 'inval'});
          this.type_decompte = 'inval';
        }
        else if(hasRule(rules.CAN_ACCESS_DECOMPTE_DC)){
          this.typesDecomptes.push({ text: 'Décès', value: 'dc'});
          this.type_decompte = 'dc';
        }
      },
      search(){
        this.initFields();
        if (this.validateData()) {
          this.noSearch = 'search';
          this.fromEG = true
          //this.whichTable();
          this.$store.commit("IS_LOADING", true);
          this.$refs.decomptes_table.$refs.table.refresh();
        }
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.num_decompte === ''
          && this.montant_decompte === ''
          && this.type_decompte === ''
          && this.statut_decompte === ''
          && this.date_au === ''
          && this.date_du === ''
          && this.date_chargement_debut_decompte === ''
          && this.date_chargement_fin_decompte === ''
          && this.nom === ''
          && this.prenom === ''
          && this.nir === ''
          && this.siren === ''
          && this.nic === ''
          && this.raison_sociale === ''
          && this.numero_contrat === ''
          && this.famille_produit === ''
          && this.nom_cev === ''
          && this.prenom_cev === ''
          && this.amountStatus === ''
          && this.email_cev === '') {
          valid = false;
          this.errors.critere_recherche = 'Vous devez sélectionner au moins un critère de recherche';
        }
        return valid;
      },
      clearErrors() {
        this.errors.critere_recherche = '';
      },
      clearForm() {
        this.num_decompte = '';
        this.montant_decompte = '';
        this.type_decompte = 'dcinval';
        this.statut_decompte = '';
        this.date_du = '';
        this.date_au = '';
        this.date_chargement_debut_decompte = '';
        this.date_chargement_fin_decompte = '';
        this.nom = '';
        this.prenom = '';
        this.nir = '';
        this.siren = '';
        this.nic = '';
        this.raison_sociale = '';
        this.numero_contrat = '';
        this.famille_produit = '';
        this.nom_cev = '';
        this.prenom_cev = '';
        this.email_cev = '';
        this.decompteIds = null;
        this.amountStatus = '';
      },
      handleError() {
        this.$store.commit("IS_LOADING", false);
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support Dosi.',
          showConfirmButton: false,
          timer: 4000
        });
      },
      initFields() {
        this.isReady = false;
        this.decompteIds = null;
      },
      triggerExportAllDecomptesInval({search_data, data}) {
        // console.log('data',data)
        this.exportAllDecomptesInval(search_data, data);
      },
      exportAllDecomptesInval(searchData, data) {
        if (searchData.length !== 0) {
          if (isEmpty(data)) {
            this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Il n\'y a aucun décompte à exporter.',
                showConfirmButton: false,
                timer: 6000
              });
          } else {
            let self =this;
            let name = 'export_all_decomptes_' + this.getTimestamp();
            let ext = 'csv';
            searchData['forExport'] = true;
            this.$store.commit('IS_LOADING', true);
            this.$axios.post('/espaceBeneficiaire/beneficiaires/exportAllDecomptes', searchData, {responseType: 'arraybuffer'})
              .then(response => {
                downloadFile(response, name, ext);
              })
              .catch(function (error) {
                let errorText = 'Une erreur est survenue pendant la génération de l\'export, si le problème persiste merci de faire un ticket au support DOSI';
                if (!isEmpty(error) && error.response && error.response.status === 403) {
                  errorText = 'Vous n\'avez pas le droit d\'effectuer cette opération';
                } else if (!isEmpty(error) && error.response && error.response.status === 428) {
                  // console.log(JSON.parse(Buffer.from(error.response.data).toString('utf8')))
                  errorText = JSON.parse(Buffer.from(error.response.data).toString('utf8')).message;
                }
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: errorText,
                  showConfirmButton: false,
                  timer: 5000
                });
              })
              .finally(() => self.$store.commit('IS_LOADING', false));
          }

        }
      },
    }
  };
</script>
<style scoped>
  tr.VueTables__row td {
    line-height: 15px;
    padding: 0 0.75rem;
  }

  .formatted-box {
    white-space: nowrap !important;
    max-width: 100% !important;
  }
</style>
